'use strict';

import paypal from 'public/js/components/paypal';

const initPaypalButtons = () => {
	rp$('.cart-listing').on('click', '.paypal-button', (e) => {
		paypal.doPaypalCheckout(e);
	});
};

export default {
	initPaypalButtons,
};
